import React, { useRef, useState } from 'react';
import './header.scss';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { CustomButton, UserAvatar, Popup, ToastNotification } from 'components/shared/';
import jwtWorker from 'utils/jwt-worker';
import utils, { BASE_ROUTES, CUSTOM_MESSAGES } from 'utils';
import { Logout, UserEditInfo, AgentStatus, ProfileDropdownMenu } from 'components/pages';


export function Header() {

    const history = useHistory();
    const toastRef = useRef();
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);
    const [confirmlogout, setConfirmlogout] = useState(false);
    const [showProfilePopup, setShowProfilePopup] = useState(false);

    const TAB_ITEMS = [
        { label: "Folders", icon: "bi bi-folder-fill", route: BASE_ROUTES.FOLDERS_ROUTE },
        { label: "Tasks", icon: "bi bi-inboxes-fill", route: BASE_ROUTES.TASKS_ROUTE },
        { label: "Supervision", icon: "bi bi-briefcase-fill", route: `${BASE_ROUTES.SUPERVISION_ROUTE}/agents-status` },
        { label: "Admin", icon: "bi bi-gear-wide-connected", route: `${BASE_ROUTES.ADMIN_ROUTE}/users` },
        { label: "Analytics", icon: "bi bi-bar-chart-fill", route: `${BASE_ROUTES.ANALYTICS_ROUTE}/flux-activity` }
    ]
    const dropdownProfileItems = [
        { label: "My Profile", icon: "pi pi-user", action: () => setShowProfilePopup(true) },
        { label: "Reset Password", icon: "pi pi-lock", action: () => { jwtWorker.decodeJWT().typeAuth === 1 ? toastRef.current.showToast({ type: "info", title: "Feedback info", message: CUSTOM_MESSAGES.ACTION_DENIED_4LDAP_USERS }) : history.push(`${BASE_ROUTES.CHANGE_PASSWORD}?username=${jwtWorker.getSubFromToken()}`) } }
    ]
    // .filter(item => {
    //         if (item.key === 1)
    //             return jwtWorker.decodeJWT()?.typeAuth === 0; else return true;
    //     })

    //MANAGE ACTIVE ITEM ACCORDING TO CURRENT ROUTE
    function isActiveLink(route) {
        let prefixRoute = route?.split('/')[1];
        return history.location.pathname.includes(prefixRoute);
    }

    //MENU TAB ITEMS
    const MenuTabItem = (props) => {
        return (
            <li className="nav-item">
                <Link onClick={props.onClick} to={props.route}
                    className={"nav-link " + (isActiveLink(props.route) && " active-nav-item")}>
                    <i className={props.icon} /> {props.label}
                </Link>
            </li>
        );
    }

    return (
        <nav class="navbar navbar-expand-lg navbar-light bg-light" style={{ marginBottom: 0, padding: "0.2rem" }}>
            <div class="container-fluid">

                {/* <button type="button" id="sidebarCollapse" class="btn btn-primary" style={{ padding: "0.1rem 0.4rem" }} onClick={(e) => { document.getElementById("sidebar").classList.toggle("active") }}>
                    <i class="bi bi-list"></i>
                </button> */}

                <ul class="left-nav navbar-nav ml-auto nav">
                    {
                        TAB_ITEMS.map(item => <MenuTabItem label={item.label} icon={item.icon} route={item.route} />)
                    }
                </ul>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="nav navbar-nav ml-auto">

                        <div class="nav nav-item-dropdown mt-1">
                            <AgentStatus />
                        </div>

                        <div className="nav nav-item-dropdown">
                            <ProfileDropdownMenu
                                toggleElement={<UserAvatar label={jwtWorker.getSubFromToken().slice(0, 2).toUpperCase()} />}
                                header={{ label: `${utils.shorthandString(jwtWorker.decodeJWT()["fullName"], 15)}`, icon: "far fa-user-circle", subLabel: jwtWorker.decodeJWT()["email"] ? jwtWorker.decodeJWT()["email"].toUpperCase() : jwtWorker.getSubFromToken() }}
                                items={dropdownProfileItems}
                                footer={{ label: "Logout", icon: "pi pi-sign-out", action: () => setShowLogoutPopup(true) }}
                            />
                        </div>

                        <Popup
                            header='Confirmation'
                            dismissable={true}
                            visible={showLogoutPopup}
                            onHide={() => {
                                setShowLogoutPopup(false);
                                setConfirmlogout(false);
                            }}>

                            <div className='confirmation-content'>
                                <i className='pi pi-question-circle p-mr-3'
                                    style={{ fontSize: '2rem', margin: '0.5rem' }} />
                                <span>Are you sure you want to logout?</span>
                            </div>
                            <div style={{ float: 'right', marginTop: '1rem' }}>
                                {!confirmlogout ?
                                    <>  <CustomButton label='No' icon='pi pi-times' id='no-btn' onClick={() => {
                                        setShowLogoutPopup(false);
                                        setConfirmlogout(false)
                                    }} className='p-button-text' />&nbsp;
                                        <CustomButton label='Yes' icon='pi pi-check' id='yes-btn' onClick={() => {
                                            setConfirmlogout(true)
                                        }} autoFocus />
                                    </> : <Logout />}
                            </div>
                        </Popup>

                        <Popup
                            header='User informations'
                            dismissable={true}
                            visible={showProfilePopup}
                            onHide={() => setShowProfilePopup(false)}>
                            <UserEditInfo username={jwtWorker.getSubFromToken()} />
                        </Popup>

                        <ToastNotification ref={toastRef} />
                    </ul>
                </div>
            </div>
        </nav>
    );
}